// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: 56MdrFCtUn

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SectionHeader from "../../SectionHeader"; // plasmic-import: Isc1ACYDLI/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSecDiv.module.css"; // plasmic-import: 56MdrFCtUn/css

createPlasmicElementProxy;

export type PlasmicSecDiv__VariantMembers = {};
export type PlasmicSecDiv__VariantsArgs = {};
type VariantPropType = keyof PlasmicSecDiv__VariantsArgs;
export const PlasmicSecDiv__VariantProps = new Array<VariantPropType>();

export type PlasmicSecDiv__ArgsType = {};
type ArgPropType = keyof PlasmicSecDiv__ArgsType;
export const PlasmicSecDiv__ArgProps = new Array<ArgPropType>();

export type PlasmicSecDiv__OverridesType = {
  root?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  sectionHeader?: p.Flex<typeof SectionHeader>;
};

export interface DefaultSecDivProps {
  className?: string;
}

const __wrapUserFunction =
  globalThis.__PlasmicWrapUserFunction ?? ((loc, fn) => fn());
const __wrapUserPromise =
  globalThis.__PlasmicWrapUserPromise ??
  (async (loc, promise) => {
    return await promise;
  });

function PlasmicSecDiv__RenderFunc(props: {
  variants: PlasmicSecDiv__VariantsArgs;
  args: PlasmicSecDiv__ArgsType;
  overrides: PlasmicSecDiv__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <SectionHeader
          data-plasmic-name={"sectionHeader"}
          data-plasmic-override={overrides.sectionHeader}
          className={classNames("__wab_instance", sty.sectionHeader)}
          variant={"divider" as const}
        />
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "sectionHeader"],
  freeBox: ["freeBox", "sectionHeader"],
  sectionHeader: ["sectionHeader"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  sectionHeader: typeof SectionHeader;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSecDiv__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSecDiv__VariantsArgs;
    args?: PlasmicSecDiv__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSecDiv__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSecDiv__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicSecDiv__ArgProps,
          internalVariantPropNames: PlasmicSecDiv__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSecDiv__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSecDiv";
  } else {
    func.displayName = `PlasmicSecDiv.${nodeName}`;
  }
  return func;
}

export const PlasmicSecDiv = Object.assign(
  // Top-level PlasmicSecDiv renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    sectionHeader: makeNodeComponent("sectionHeader"),

    // Metadata about props expected for PlasmicSecDiv
    internalVariantProps: PlasmicSecDiv__VariantProps,
    internalArgProps: PlasmicSecDiv__ArgProps
  }
);

export default PlasmicSecDiv;
/* prettier-ignore-end */
